module.exports = __webpack_public_path__ + "img/rank-right.9668f822.png";